import * as angular from "angular";

angular
  .module('bringoz.admin.itineraries', [
    'bringoz.admin.commissions',
    // 'yaru22.angular-timeago',
    'ui.tree'
  ])
